export async function encryptPayload(data: Record<string, any>): Promise<string> {
  const payload = new TextEncoder().encode(JSON.stringify(data));

  const keyRaw = atob('BU8RFU+wfYRUCfTNWcno3Tab9yD1s7e0mcS/yQUPvTk=');
  const ivRaw = atob('IjVvo5GvRvgJytx/7g2PRw==');

  // Convert raw key to CryptoKey
  const keyBuffer = Uint8Array.from(keyRaw, (c) => c.charCodeAt(0));
  const ivBuffer = Uint8Array.from(ivRaw, (c) => c.charCodeAt(0));

  const cryptoKey = await crypto.subtle.importKey(
    'raw',
    keyBuffer,
    { name: 'AES-CBC' },
    false,
    ['encrypt']
  );

  // Encrypt payload
  const encryptedBuffer = await crypto.subtle.encrypt(
    { name: 'AES-CBC', iv: ivBuffer },
    cryptoKey,
    payload
  );

  // Convert ArrayBuffer to base64 string
  return btoa(String.fromCharCode(...new Uint8Array(encryptedBuffer)));
}